// Open House — the new Post a Project's editing steps (minimums.md, Editing and
// Last screen): Editing style (with the word count) → About your manuscript →
// Review & post.
//
// Today's two required boxes, intended audience and themes, fold into the
// short description; subtitle, previous editing and additional information
// moved to the editing preferences after posting. Fields shared with today's
// form are today's field objects (lib/post/services/editing.js): niche and
// US/UK English keep today's rule and hide for Developmental Editing. The
// manuscript is today's required editing file (.doc or .docx), saved through
// the draft save queue like every answer.

import { editing } from "@/lib/post/services/editing"
import { REVIEW_STEP, SENSITIVE_ALIASES, descriptionField, railWith } from "./bookWritingSteps"
import { WORDING } from "./wording"

export const EDITING_DEFAULTS = {}
export const EDITING_ALIASES = SENSITIVE_ALIASES

export const MANUSCRIPT_ACCEPT = ".doc,.docx"

export const isPendingFile = (value) => typeof File !== "undefined" && value instanceof File

export const isManuscriptFile = (file) =>
  MANUSCRIPT_ACCEPT.split(",").some((ext) => String(file?.name || "").toLowerCase().endsWith(ext))

// A chosen file counts once its save succeeded (the saved { name }); one still
// uploading, or waiting for a retry, does not.
function manuscriptIssue(values) {
  const value = values.file
  if (isPendingFile(value)) return WORDING.manuscriptUploading
  return value?.name ? null : WORDING.manuscriptMissing
}

const MANUSCRIPT_FIELD = {
  type: "manuscript",
  key: "file",
  required: true,
  label: WORDING.manuscriptLabel,
  issue: manuscriptIssue,
  reviewValue: (values) => (values.file && !isPendingFile(values.file) ? values.file.name : null),
}

export function editingSteps() {
  const [style, manuscript] = editing.steps()
  const field = (key) => manuscript.fields.find((f) => f.key === key || f.type === key)

  return [
    {
      id: "style",
      node: style.title,
      title: style.title,
      sub: style.sub,
      fields: [{ ...style.fields[0], reviewLabel: style.title }, field("word_count")],
    },
    {
      id: "manuscript",
      node: manuscript.title,
      title: manuscript.title,
      sub: manuscript.sub,
      fields: [
        field("title"),
        descriptionField(WORDING.editingDescriptionHelp, WORDING.editingDescriptionPlaceholder, WORDING.editingDescriptionError),
        MANUSCRIPT_FIELD,
        field("niche"),
        field("english_type"),
        field("nsfw"),
        field("triggerWarning"),
      ],
    },
    REVIEW_STEP,
  ]
}

export const editingRail = (values, ctx) => railWith(editing, values, ctx)
